module.exports = __webpack_public_path__ + "static/media/plan-B8-mobile-sc.6ea97f6d.png";